import {API,Endpoints} from '@brg/api';
import {useEffect, useState} from "react";

export const useGetAudioPost = (postId?: string) =>  {
    const [resp, setResp] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {

        setError(false);
        setResp(null);
        setIsLoading(true);

        if (!postId) {
            setIsLoading(false);
            return;
        }

        API.request()
            .endpoint(Endpoints.longread)
            .url('/api/post/Get')
            .get()
            .addQuery('idUser', '1')
            .addQuery('idPost', postId)
            .send()
            .then((r) => r.json())
            .then((r) => {
                setIsLoading(false)
                setResp(r)
            })
            .catch((e) => {
                setIsLoading(false)
                setError(true)
            })

    }, [postId])

    return [resp, isLoading, error];
}import {API,Endpoints} from '@brg/api';
import {useEffect, useState} from "react";

export const useGetAudioPost = (postId?: string) =>  {
    const [resp, setResp] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {

        setError(false);
        setResp(null);
        setIsLoading(true);

        if (!postId) {
            setIsLoading(false);
            return;
        }

        API.request()
            .endpoint(Endpoints.longread)
            .url('/api/post/Get')
            .get()
            .addQuery('idUser', '1')
            .addQuery('idPost', postId)
            .send()
            .then((r) => r.json())
            .then((r) => {
                setIsLoading(false)
                setResp(r)
            })
            .catch((e) => {
                setIsLoading(false)
                setError(true)
            })

    }, [postId])

    return [resp, isLoading, error];
}